// extracted by css-extract-rspack-plugin
export default {"container":"_38c8525","title":"_ca706bc2","shimmerLoadingBackground":"_dc62c2cf","tileContainer":"_e8c502d1","tile":"_f4cf99f6"};